module.exports = "/fonts/fa-brands-400.woff2?9f4ce3dc689981a1b87faab0f5484f9e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-brands-400.woff2
// module id = KFky
// module chunks = 0 1